// start:ng42.barrel
export * from './messages.component';
// end:ng42.barrel




// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/messages/index.ts